<template>
  <!-- 新建档案 -->
  <div class="stu-file-container">
    <div class="form-section">
      <form :model="neweditForm" ref="neweditForm">
        <!-- 基础资料 -->
        <div class="title-block">
          <img src="~@/assets/images/file_title_bg.png"/>
          <div class="title">我的档案</div>
        </div>
        <div class="info-block">
          <div class="info-item">
            <div class="item-label">考生姓名</div>
            <el-input class="item-input" v-model="neweditForm.name" placeholder="请输入"></el-input>
          </div>
          <div class="info-item" style="width: 440px">
            <div class="item-label">考生性别</div>
            <el-radio class="item-radio" v-model="neweditForm.sex" :label="0">男</el-radio>
            <el-radio class="item-radio" v-model="neweditForm.sex" :label="1">女</el-radio>
          </div>
          <div class="info-item">
            <div class="item-label">考生民族</div>
            <el-select class="item-select" v-model="neweditForm.nation" placeholder="请选择">
              <el-option
                v-for="item in minzu"
                :key="item.dictName"
                :label="item.dictName"
                :value="item.dictName">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="info-block">
          <div class="info-item">
            <div class="item-label">高考年份</div>
            <el-input class="item-input" v-model="neweditForm.year" disabled placeholder="请输入"></el-input>
          </div>
          <div class="info-item">
            <div class="item-label">考生学校</div>
            <el-input class="item-input" v-model="neweditForm.school" placeholder="请输入"></el-input>
          </div>
          <div class="info-item">
            <div class="item-label">注册电话</div>
            <el-input class="item-input" v-model="neweditForm.phone" disabled placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="info-block">
          <div class="info-item">
            <div class="item-label">首选科目</div>
            <el-select class="item-select" v-model="neweditForm.major" :disabled="stuMajorDisabled" placeholder="请选择">
              <el-option
                v-for="item in majorList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="info-item">
            <div class="item-label">再选科目1</div>
            <el-select class="item-select" v-model="neweditForm.subject1" :disabled="stuSubject1Disabled" placeholder="请选择">
              <el-option
                v-for="item in subjectList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="info-item">
            <div class="item-label">再选科目2</div>
            <el-select class="item-select" v-model="neweditForm.subject2" :disabled="stuSubject2Disabled" placeholder="请选择">
              <el-option
                v-for="item in subjectList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="info-block">
          <div class="info-item">
            <div class="item-label">高考成绩</div>
            <el-input class="item-input" v-model="neweditForm.score" disabled placeholder="请输入"></el-input>
          </div>
          <div class="info-item">
            <div class="item-label">高考位次</div>
            <el-input class="item-input" v-model="neweditForm.precedence" disabled placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="info-block">
          注：</br>
          1.高考年份考生在系统注册时，请真实填写高考年份、注册电话及选考科目，系统注册后，相关内容不可修改。</br>
          2.非高考年份考生，选考科目可进行修改，在考生高考年份1月1日后，系统自动提示确定选考科目，选考科目确定后，不可修改。</br>
          3.高考出分后，系统提示考生填写真实高考成绩以及位次，填写完成后系统锁定不可修改。</br>
          </br></br>
        </div>
        <div class="btn-box" style="display: flex; justify-content: center;margin-bottom: 40px">
          <el-button type="primary" @click="updateStuFn()">确认修改</el-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {request} from "@/util/request"

const MajorData = [
  {
    label: '物理组',
    value: 1
  },
  {
    label: '历史组',
    value: 2
  }
]

export default {
  data() {
    return {
      majorList: MajorData,
      subjectList: [
        {
          label: '化学',
          value: '化学'
        },
        {
          label: '生物',
          value: '生物'
        },
        {
          label: '政治',
          value: '政治'
        },
        {
          label: '地理',
          value: '地理'
        }
      ],
      neweditForm: {},
      infos: {},
      minzu:[],
      stuMajorDisabled: false,
      stuSubject1Disabled: false,
      stuSubject2Disabled: false,
    }
  },
  methods: {
    getStu () {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.infos.userId
        }
      }).then(res => {
        this.neweditForm = res.data;
        this.neweditForm.year = this.infos.year;
        this.neweditForm.phone = this.infos.phone;
        //用户是否可以修改选科
        if(res.data.disabledMajor){
          this.stuMajorDisabled = true;
          this.stuSubject1Disabled = true;
          this.stuSubject2Disabled = true;
        }
      })
    },
    // 获取民族
    getMinzu() {
      request({
        method: 'Get',
        url: 'sysDict/getDict',
        params: {
          dictType: 'nation_type'
        }
      }).then(res => {
        this.minzu = res.data
      })
    },
    updateStuFn() {
      if (this.neweditForm.name && this.neweditForm.major) {
        if (this.neweditForm.subject1 == this.neweditForm.subject2) {
          this.$message({
            message: '再选科目1和再选科目2不能相同！',
            type: 'error'
          });
          return;
        }
        request({
          method: 'post',
          url: 'students/saveOrUpdateArchives',
          data: this.neweditForm
        }).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            this.infos.subject1 = this.neweditForm.subject1;
            this.infos.subject2 = this.neweditForm.subject2;
            this.infos.major = this.neweditForm.major;
            localStorage.setItem("stu", JSON.stringify(this.infos));
          } else {
            this.$message({
              message: '操作失败~',
              type: 'error'
            });
          }
          return;
        })
      } else {
        this.$message({
          message: '姓名与科类不能为空！',
          type: 'error'
        });
      }
    },
  },
  created() {
    this.infos = this.$route.params.info
    this.infos = JSON.parse(sessionStorage.getItem("user"))
    this.getStu();
    this.getMinzu();
  }
}
</script>

<style lang="stylus" scoped>
pageWidth = 1400px
$color-theme = #f96630
.stu-file-container
  width: pageWidth;
  margin: 0 auto;
  font-size: 14px;

  div
    box-sizing: border-box;

  .nav-section
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 0;
    font-size: 16px;

    .nav-block
      flex 1
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title
        width: 100px;

      img
        display: block;
        width: 18px;
        height: 18px;
        margin-right: 10px;

      i
        margin: 0 2px;

    .stu-info
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 166px;
      height: 40px;
      padding: 0 10px;
      font-size: 14px;
      // background: #FFF2E7;
      color: #333;

      img
        display: block;
        width: 16px;
        margin-right: 15px;

      span
        margin-left: 10px;

  .form-section
    padding: 0 20px;
    background: #fff;
    border-radius: 6px;

    .title-block
      position: relative;
      width: 100%;
      padding: 20px 0;
      font-size: 18px;

      .title
        position: absolute;
        top: 20px;
        left: 45px;
        z-index: 0;
        line-height: 30px;
        color: #fff;

      img
        display: block;
        width: 164px;
        height: 30px;

    .tips
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      color: #999;

    .info-block, .info-block-show
      display: flex;
      align-items: center;
      padding: 10px 0

      .info-item
        display: flex;
        align-items: center;
        padding-bottom: 16px;

        .item-label
          width: 150px;
          margin-right: 10px;
          text-align: right;

        .item-label-intention
          width: 40px;
          margin-right: 10px;
          text-align: left;

        .paper-item-label
          width: 100px;
          margin-right: 10px;

        .item-input, .item-select, .item-editor-date, .item-cascader, .item-input-unit
          width: 280px;
          height: 40px;

        .item-cascader-spec
          width: 180px;

        .item-radio
          width: 60px;
          margin-right: 0;

        .item-spec-label
          width: 120px;

      .spec-score-item
        flex: 1;
        color: #333;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 2px;

      .score-item
        flex: 1.4;
        color: #333;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 5px;

      .score-item-opt
        width: 80px;
        padding: 0 5px;
        color: #333;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

    .info-block-show
      background: #F9F9F9;

      .score-item-opt
        justify-content: space-between;

    .class-block
      padding: 10px 0
      display: flex
      flex-wrap wrap

      .class-item
        width 25%
        padding-bottom: 16px;
        display: flex;
        align-items: center;

        .class-label
          width: 80px;
          padding-right: 6px;
          text-align: right;

        .class-textarea
          flex: 1;

    .prefer-title
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      font-weight: 500;
      color: #FC6621;

    .prefer-block
      padding: 10px 0

      .prefer-item
        padding-bottom: 16px;
        display: flex;
        align-items: center;

        .prefer-input
          margin-left: 10px;

    .conclusion-block
      padding: 10px 0
      font-size: 16px;

      .conclusion-title
        line-height: 36px;
        font-weight: 500;
        color: #333;

      .conclusion-desc
        line-height: 30px;
        color: #666;

      .conclusion-item
        display: flex;
        align-items: center;
        padding: 10px 0;

        .title
          width: 170px;
          margin-right: 30px;
          line-height: 36px;
          font-weight: 500;
          color: #333;

    .save-block
      padding-bottom: 50px;
      text-align: center;

.right-btn-box
  position: fixed;
  top: 50%;
  margin-top: -120px;
  right: 10px;
  width: 60px;
  z-index 999
  .el-button
    width: 60px;
    height: 60px;
    padding: 0;
    margin-bottom: 20px;
    text-align center
    color: #fff;
  .el-button+.el-button
    margin-left: 0;
</style>
<style lang="stylus">
$color-theme = #f96630
.stu-file-container
  .form-section
    .info-block
      .score-item, .spec-score-item
        .el-input__inner
          padding: 0 4px;

  .score-item-opt
    .del
      color: #ff0000;

    .sort-up
      color: #67C23A;

    .sort-down
      color: $color-theme;
</style>
